import React from 'react';
import axios from 'axios';
import { Input, Select, Form, Segment, Button, Checkbox } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class ContractInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            number: null,
            date: null,

            contractTypes: [],
            contractType: null,

            startDate: null,
            endDate: null,
            fullTime: false,
            comment: null,
            startDateP: null,
            endDateP: null,

            numberErr: false,
            dateErr: false,
            contractTypeErr: false,
            startDateErr: false,
            startDatePErr: false,
            endDatePErr: false,
            endDateErr: false,

        };

        this.saveContractInfo = this.saveContractInfo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        axios.get('contract-types')
            .then(res => {
                this.setState({
                    contractTypes: res.data.map(el => (
                        {
                            ...el, key: el.id, value: el.id, text: el.name
                        }
                    ))
                });
            })
            .catch(err => {
                console.log('Failed to fetch contract types.');
            });
    }


    saveContractInfo() {
        const {
            number, date, contractType, startDate, endDate, comment, startDateP, endDateP, fullTime
        } = this.state;

        if (!number || !date || !contractType || !startDate || (localStorage.getItem('associate') !== 'true' && !startDateP) || ((localStorage.getItem('associate') !== 'true' && contractType !== 1) && !endDateP) || ((localStorage.getItem('associate') !== 'true' && contractType !== 1) && !endDate)) {
            toast('Niste unijeli obavezna polja.');
            if (!number) { this.setState({ numberErr: true }); } else { this.setState({ numberErr: false }); }
            if (!date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!contractType) { this.setState({ contractTypeErr: true }); } else { this.setState({ contractTypeErr: false }); }
            if (!startDate) { this.setState({ startDateErr: true }); } else { this.setState({ startDateErr: false }); }
            if (!startDateP) { this.setState({ startDatePErr: true }); } else { this.setState({ startDatePErr: false }); }
            if (localStorage.getItem('associate') !== 'true' && !startDateP) { this.setState({ startDatePErr: true }); } else { this.setState({ startDatePErr: false }); }
            if ((localStorage.getItem('associate') !== 'true' && contractType !== 1) && !endDateP) { this.setState({ endDatePErr: true }); } else { this.setState({ endDatePErr: false }); }
            if ((localStorage.getItem('associate') !== 'true' && contractType !== 1) && !endDate) { this.setState({ endDateErr: true }); } else { this.setState({ endDateErr: false }); }
        } else {
            let obj = {
                employee: {
                    id: JSON.parse(localStorage.getItem('employee')).id
                },
                employmentContract: {
                    number,
                    date,
                    contractType: { id: contractType },
                    startDate,
                    endDate,
                    fullTime,
                    active: true,
                    comment
                },
                pioMio: {
                    startDate: startDateP,
                    endDate: endDateP,
                }

            };

            axios.post('hr/employee/employment-info/save/', { ...obj })
                .then(res => {
                    localStorage.setItem('employee', JSON.stringify(res.data));
                    this.props.showInfo();
                })
                .catch(err => {
                    console.log('Failed to save employment contract info.');
                });
        }
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        return (
            <div>
                <Segment.Group raised>
                    <Segment>
                        <h3>{JSON.parse(localStorage.getItem('person')).firstName} {JSON.parse(localStorage.getItem('person')).lastName} - podaci o ugovoru</h3>
                    </Segment>
                    <Segment clearing>
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    error={this.state.numberErr}
                                    control={Input}
                                    label="Broj ugovora"
                                    placeholder="Unesite broj ugovora"
                                    value={this.state.number}
                                    name="number"
                                    onChange={this.handleInputChange}
                                />
                                <Form.Field
                                    required
                                    error={this.state.contractTypeErr}
                                >
                                    <label>Tip ugovora</label>
                                    <Form.Dropdown
                                        selection
                                        options={this.state.contractTypes}
                                        onChange={this.handleInputChange}
                                        value={this.state.contractType}
                                        name="contractType"
                                        placeholder="Odaberite tip ugovora"
                                        search
                                        fluid
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>&nbsp;</label>
                                    <Checkbox
                                        checked={this.state.fullTime}
                                        label={<label>Puno radno vrijeme</label>}
                                        value={this.state.fullTime}
                                        onChange={(e) => this.setState({ fullTime: !this.state.fullTime })}
                                    />
                                </Form.Field>

                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    error={this.state.dateErr}
                                >
                                    <label>Datum zaključenja ugovora</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'date')}
                                        value={this.state.date}
                                    />
                                </Form.Field>
                                <Form.Field
                                    required
                                    error={this.state.startDateErr}
                                >
                                    <label>Početak radnog odnosa</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'startDate')}
                                        value={this.state.startDate}
                                    />
                                </Form.Field>
                                <Form.Field
                                    disabled={this.state.contractType === 1}
                                    required={this.state.contractType !== 1}
                                    error={this.state.endDateErr}
                                >
                                    <label>Kraj radnog odnosa</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'endDate')}
                                        value={this.state.endDate}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <br />
                            <br />
                            <Form.Group widths="equal">
                                <Form.Field
                                    required={localStorage.getItem('associate') !== 'true'}
                                    error={this.state.startDatePErr}
                                >
                                    <label>Datum prijave na PIO/MIO</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'startDateP')}
                                        value={this.state.startDateP}
                                    />
                                </Form.Field>
                                <Form.Field
                                    disabled={this.state.contractType === 1}
                                    required={this.state.contractType !== 1 && localStorage.getItem('associate') !== 'true'}
                                    error={this.state.endDatePErr}
                                >
                                    <label>Datum odjave sa PIO/MIO</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'endDateP')}
                                        value={this.state.endDateP}
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>
                            <Button color="blue" floated="right" onClick={this.saveContractInfo}>Sačuvaj podatke</Button>
                        </Form>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/HR/add/ContractInfo.js